<div *ngIf="item != undefined">

    <mat-form-field appearance="outline" style="width: 100%;">
        <mat-select 
        [value]="item.type"
        (selectionChange)="saveItemType($event.value)" 
        placeholder="">
            <mat-option *ngFor="let type of allItemTypes;" [value]="type.name">{{type.nicename}}</mat-option>
        </mat-select>
        <button mat-button matSuffix (click)="switchToTemplateEditor()">
            <mat-icon matSuffix>code</mat-icon>
        </button>
    </mat-form-field>

    <mat-card *ngIf="item.status != 'Sold' && item.status != 'Archived'">
        <mat-card-content>
            <button mat-raised-button>Item Data</button>
            <button [routerLink]="['ebay']" mat-raised-button>Ebay</button>
            <button mat-raised-button>Facebook</button>
            <button mat-raised-button>Webflow</button>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Actions</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <button 
            [disabled]="item.status == 'Archived'"
            (click)="toggleCheckout()" mat-raised-button [color]="item.status=='checked-out' ? 'primary' : 'basic'">{{item.status == 'checked-out' ? 'Check In' : 'Checkout'}}</button>


            <!-- <button (click)="archive()" mat-raised-button [color]="item.status=='Archived' ? 'primary' : 'basic'">Archive</button> -->

            <div class="reset" *ngIf="item.status=='Sold' || item.status=='Archived'">
                <span (click)="resetStatus()">Reset</span> <span title="Double click to delete" (dblclick)="delete()">Delete</span>
            </div>
        </mat-card-content>
    </mat-card>
</div>